var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApprovalsActive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m.33 1.4.22.14 8.9 5.84a1 1 0 0 0 1.1 0l8.9-5.84.22-.14A2 2 0 0 0 18 .5H2a2 2 0 0 0-1.67.9M20 3.57l-8.35 5.48a3 3 0 0 1-3.3 0L0 3.57v9.93c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgApprovalsActive);
export default ForwardRef;